import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { PlatformLocation } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { ViewStateService } from "../../shared/services/view-state.service";
import { UserService } from "../../shared/services/user.service";
import { DirectoryService } from "./../shared/services/directory.service";
import { PractitionerService } from "./../../practitioner/shared/services/practitioner.service";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-badge",
  templateUrl: "./badge.component.html",
  styleUrls: ["./badge.component.css"],
})
export class BadgeComponent implements OnInit, OnDestroy {
  @Input() personId: string;
  badgeId: string;
  person: any;
  private destroy$ = new Subject<void>();

  constructor(
    private directoryService: DirectoryService,
    private viewState: ViewStateService,
    private route: ActivatedRoute,
    private userService: UserService,
    private practitionerService: PractitionerService,
    private platformLocation: PlatformLocation
  ) {}

  ngOnInit() {
    this.badgeId = this.route.snapshot.params["badgeId"];
    this.handleFormResult();
    this.viewState.isBadge(true);
  }

  private handleFormResult() {
    this.viewState.startLoading();

    const badgeRequest$ = this.personId
      ? this.practitionerService.getBadge(this.personId)
      : this.directoryService.getBadge(this.badgeId);

    badgeRequest$.pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.person = res;
        this.viewState.stopLoading();
      },
      (e) => {
        this.viewState.stopLoading();
      }
    );
  }

  needsBaseCredential(testCred) {
    if (testCred == "ACCS" || testCred == "NPS" || testCred == "SDS") {
      return true;
    }
    return false;
  }

  altCredentialDate(cert, altTextDate: string) {
    const compareDate = cert.certificationDate.substring(0, 10);
    return compareDate === altTextDate;
  }

  validBadge() {
    if (this.person && this.person.certifications && this.person.lastName)
      return true;
    else return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
